import { createSlice } from '@reduxjs/toolkit';
import type { CurrentProfileState, ProfileState } from './types';
import { getProfileBuilder, updateProfileBuilder, getCurrentProfileBuilder } from './reducers';

const initialState: ProfileState = {
  isProfileFetching: false,
  isProfileUpdating: false,
  profile: null,
};

const initialCurrentProfileState: CurrentProfileState = {
  isProfileFetching: false,
  profile: null,
  userRole: null,
};

const currentProfileSlice = createSlice({
  name: 'currentProfile',
  initialState: initialCurrentProfileState,
  reducers: {},
  extraReducers: (builder) => {
    getCurrentProfileBuilder(builder);
  },
});

const profileSlice = createSlice({
  name: 'profile',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    getProfileBuilder(builder);
    updateProfileBuilder(builder);
  },
});

export const profileReducer = profileSlice.reducer;
export const profileActions = profileSlice.actions;

export const currentProfileReducer = currentProfileSlice.reducer;
export const currentProfileActions = currentProfileSlice.actions;
